import React, { useEffect } from "react";
import {
  CheckOutlined,
  ExclamationCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";

const PopupCard = ({
  type = "success",
  title = "",
  message = "",
  showActions = false,      // ✅ show/hide buttons
  showConfirmOnly = false,  // ✅ show only confirm button (e.g. for warning/session expired)
  onConfirm = () => {},     // ✅ callback for confirm
  onCancel = () => {},      // ✅ callback for cancel
  confirmText = "Confirm",  // ✅ customizable button labels
  cancelText = "Cancel",
  autoClose = false,
  autoCloseMs = 3000,
  onClose = () => {},
  confirmBtnClass = "",     // ✅ custom class for confirm button
}) => {
  useEffect(() => {
    if (!autoClose) return undefined;

    const timer = setTimeout(() => {
      onClose();
    }, autoCloseMs);

    return () => clearTimeout(timer);
  }, [autoClose, autoCloseMs, onClose]);

  const typeStyles = {
    success: {
      headerBg: "bg-[#06513D]",
      icon: <CheckOutlined style={{ fontSize: 32, color: "#ffffff" }} />,
      iconBg: "bg-[#06513D]",
      textColor: "text-[#06513D]",
    },
    warning: {
      headerBg: "bg-[#FFC107]",
      icon: <ExclamationCircleOutlined style={{ fontSize: 32 }} />,
      iconBg: "bg-[#FFC107]",
      textColor: "text-[#06513D]",
    },
    error: {
      headerBg: "bg-[#D32F2F]",
      icon: <CloseCircleOutlined style={{ fontSize: 32, color: "#ffffff" }} />,
      iconBg: "bg-[#D32F2F]",
      textColor: "text-[#000000]",
    },
  };

  const safeType = typeStyles[type] ? type : "success";
  const { headerBg, icon, iconBg, textColor } = typeStyles[safeType];

  return (
    <div className="w-full sm:w-[350px] rounded-md shadow-md overflow-hidden bg-white text-center font-sans">
      {/* Header */}
      <div className={`py-2 ${headerBg} text-white font-semibold`}>
        {title}
      </div>

      {/* Body */}
      <div className="p-6 flex flex-col items-center gap-3">
        <div
          className={`w-12 h-12 rounded-full flex items-center justify-center ${iconBg}`}
        >
          {icon}
        </div>
        <p className={`text-base font-semibold ${textColor}`}>{message}</p>

        {/* ✅ Action Buttons (for confirm dialogs) */}
        {(showActions || showConfirmOnly) && (
          <div className="flex justify-center gap-4 ">
            {!showConfirmOnly && (
              <button
                onClick={onCancel}
                className="bg-gray-300 hover:bg-gray-400 px-4 py-2 rounded-md text-sm font-semibold"
              >
                {cancelText}
              </button>
            )}
            <button
              onClick={onConfirm}
              className={`${confirmBtnClass || "bg-red-600 text-white hover:bg-red-700"} px-4 py-2 rounded-md text-sm font-semibold`}
            >
              {confirmText}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default PopupCard;
